export default __webpack_public_path__ + "static/media/score_bar_right.e83296c3.png";